var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroBtnLft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2832 13.73H6.09766C3.33623 13.73 1.09766 11.4914 1.09766 8.73V0.974187",
    stroke: "#FF7038"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBtnLft);
export default __webpack_public_path__ + "static/media/hero-btn-lft.b790df1d83387d851e10eac5c32b4ebd.svg";
export { ForwardRef as ReactComponent };